<template>
  <component
    :is="dynamicComponent"
    v-bind="filterProps(input.props, ['isFormElement', 'selectParents'])"
    :value="internalValue"
    :params="params"
    :return-object="false"
    @input="handleInput"
  />
</template>
<script>

import parseTableResourceFilter from "@/components/base_components/generic-relations-wrapper/mixins/parse-table-resource-filter-mixin";
import { filterProps } from '@/utils/functional-component-utils';

export default {
    name: "GenericFilter",
    mixins: [
        parseTableResourceFilter
    ],
    props: {
        input: { type: Object, required: true },
        valueIsFilterState: { type: Boolean, default: false }
    },
    computed: {
        dynamicComponent(){
            if (this.input.component == "w-form-autocomplete-lazy") return 'w-multiple-selection-filter-lazy'
            if (this.input.component == "w-form-autocomplete") return 'w-autocomplete'
            return this.input.component
        }
    },
    methods: {
        filterProps: filterProps,
    }
}
</script>
